import { render, staticRenderFns } from "./index.vue?vue&type=template&id=af8c152e&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=af8c152e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8c152e",
  null
  
)

export default component.exports